import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/ticketAreaButton/ticketAreaButton.sss';

export default class TicketAreaButton extends Component {
	constructor(props) {
		super(props);
		let store = Store.get() || {};
		let client = store.client || {};
		let isIOS = client.isIOS;
		this.isAndroid = client.device === 'android' || (!isIOS && !client.isDesktopSize && !client.isSafari && !client.isEdge);;
	}
	render({ text, onClick, disabled, children, isIOsSafari, isAndroidChrome }) {
		return (
			<button class={joinClasses(s.btn, this.isAndroid && s.androidBtnStyling, disabled && s.disabled, isIOsSafari && s.iosSafariBtn, isAndroidChrome && s.androidChromeBtn)} onClick={onClick} disabled={disabled}>
				{text}
				{children}
			</button>
		);
	}
}